import { css } from '@emotion/css';
import { colors } from 'constants/theme';
import bgForm from 'assets/images/bg/account-1.jpg';
import bgTitle from 'assets/images/bg/title-register.jpg';
const registerStyle = {
    wrap: css`
        overflow: hidden;
        background: #1f1040;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        .page-content {
            width: 100%;
            max-width: 1050px;
            margin: 0 auto;
            display: flex;
            border-radius: 16px;
            overflow: hidden;
        }
    `,
    left: css`
        flex: 0 0 55%;
        display: flex;
        flex-direction: column;
        /* @media (max-width: 1500px) {
            min-width: 600px;
        }
        @media (max-width: 1200px) {
            min-width: 480px;
        }
        @media (max-width: 992px) {
            min-width: 370px;
        } */
    `,
    logoPartner: css`
        display: flex;
        flex-wrap: wrap;
        flex: 1;
        background: ${colors.white};
        padding: 12px 10px;
        align-items: center;
        justify-content: space-between;
    `,
    imgReg: css`
        @media (max-width: 992px) {
            width: 63%;
        }
    `,
    partnerItem: css`
        flex: 0 0 20%;
        max-width: 20%;
        padding: 4px 4px;
        @media (max-width: 1500px) {
            flex: 0 0 25%;
            max-width: 25%;
        }
        @media (max-width: 1200px) {
            flex: 0 0 33.3%;
            max-width: 33.3%;
        }
        @media (max-width: 992px) {
            flex: 0 0 50%;
            max-width: 50%;
        }
    `,
    itemInner: css`
        /* border: 1px solid #e0e0e0; */
        padding: 2px 3px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            width: 100%;
            object-fit: contain;
            @media (max-width: 992px) {
                width: 63%;
            }
        }
    `,
    contentform: css`
        color: ${colors.white};
        flex: 0 0 450px;
        max-width: 450px;
        padding: 30px 45px;

        background: url(${bgForm}) center center no-repeat;
        background-size: cover;
    `,
    titlecontent: css`
        text-align: center;
        margin: 20px 0;
        img {
            width: 40%;
            max-width: 300px;
            min-width: 200px;
        }
    `,
    form: css`
        max-width: 480px;
        margin: auto;
    `,
    titleReg: css`
        width: 100%;
        height: 50px;
        max-width: 480px;
        border-radius: 10px;
        background: url(${bgTitle}) center center no-repeat;
        background-size: cover;
        margin-bottom: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #7c94ea;
        margin: 30px auto;
        @media (max-width: 992px) {
            width: 80%;
        }
        h6 {
            font-size: 28px;
            color: ${colors.white};
            font-weight: 500;
            margin-right: 20px;
        }
        img {
            width: 90px;
        }
    `,
    inputWrap: css`
        position: relative;
        padding-bottom: 23px;
        margin-bottom: 5px;
        @media (max-width: 992px) {
            width: 80%;
            margin: 0 auto;
        }
        label {
            font-size: 15px;
            display: block;
            margin-bottom: 10px;
            font-weight: 600;
        }
        input {
            font-size: 18px;
            padding: 8px 12px;
        }
    `,
    input: css`
        width: 100%;
    `,

    errorInput: css`
        position: absolute;
        bottom: 4%;
        left: 2px;
        width: 100%;
        small {
            font-size: 12px;
            color: ${colors.red};
        }
    `,
    textTOF: css`
        font-size: 14px;
        font-weight: 300;
    `,
    checkbox: css`
        padding-top: 10px;
        @media (max-width: 992px) {
            width: 80%;
            margin: 0 auto;
        }
    `,
    togglePass: css`
        position: absolute;
        cursor: pointer;
        right: 8px;
        top: 48px;
        transform: translateY(-50%);
        img {
            width: 18px;
        }
    `,
    btnPrimary: css`
        padding: 14px 0;
        font-weight: 500;
        border-radius: 8px;
        cursor: pointer;
        background: #e00209;
        color: ${colors.white};
        width: 100%;
        margin: 0 auto;
        font-weight: 600;
        &:hover {
            background: #c80309;
        }
        &:disabled {
            pointer-events: none;
            opacity: 0.7;
        }
    `,
};
export default registerStyle;
